import React, { useEffect } from "react";
import { Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import useQuery from 'hooks/useQuery';

import {
  Select,
  Text,
  Button,
  Modal,
  Input
} from 'v3/components'

import {
  fetchVehicle,
  fetchWagons,
  fetchVehiclesByIds,
  fetchWagonsByIds
} from 'utils/fetches';

export default function AdvancedFilterModal({
  onChange,
  loading,
  showAdvancedFiltersModal,
  setShowAdvancedFiltersModal,
  setQtdAdvancedFilters,
  setAdvancedFilters,
  advancedFilters
}) {

  const navigate = useNavigate();
  const query = useQuery();

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate({ search: query.toString() }, { replace: true });
    }, 100);

    return () => {
      clearTimeout(timeout);
    };
  }, [advancedFilters, navigate, query]);

  useEffect(() => {
    const isNotEmpty = value =>
      value !== null && value !== undefined && value !== '' && value !== 0;

    const validateAdvancedFilters = {
      vehicles: advancedFilters?.vehicles?.length,
      wagons: advancedFilters?.wagons?.length,
      idSearch: advancedFilters?.idSearch,
      expireInDays: advancedFilters?.expireInDays,
    };

    setQtdAdvancedFilters(
      Object.values(validateAdvancedFilters).filter(isNotEmpty).length
    );
  }, [advancedFilters]);

  const handlerAdvancedFilters = () => {
    onChange(advancedFilters)
    setShowAdvancedFiltersModal(false);
  }

  async function handleInitializeParams() {

    if (query.has('vehicles[]')) {
      const vehicleIds = query.getAll('vehicles[]').map(vehicle => Number(vehicle));
      const allVehicles = await fetchVehiclesByIds(vehicleIds);
      setAdvancedFilters(old => ({ ...old, vehicles: allVehicles }));
    }

    if (query.has('wagons[]')) {
      const wagonsIds = query.getAll('wagons[]').map(wagon => Number(wagon));
      const allWagons = await fetchWagonsByIds(wagonsIds);
      setAdvancedFilters(old => ({ ...old, wagons: allWagons }));
    }

    if (query.has('idSearch')) {
      const idSearch = query.get('idSearch');
      setAdvancedFilters(old => ({ ...old, idSearch }));
    }

    if (query.has('expireInDays')) {
      const expireInDays = query.get('expireInDays');
      setAdvancedFilters(old => ({ ...old, expireInDays }));
    }
  }

  useEffect(() => {
    handleInitializeParams();
  }, []);

  return (
    <>
      <Modal
        heading={
          <Text color="dark" type="header">
            Filtro Avançado
          </Text>
        }
        show={showAdvancedFiltersModal}
        handleClose={() => { setShowAdvancedFiltersModal(false) }}
        body={
          <Row>
            <Col md={6} xl={6}>
              <Select.Async
                label={'Veículos'}
                multiple
                horizontal
                onSearch={search => fetchVehicle(search)}
                value={advancedFilters.vehicles}
                onChange={value => {
                  query.delete('vehicles[]');
                  if (value?.length) {
                    value.forEach(v => {
                      query.append('vehicles[]', v.id);
                    })
                  }
                  setAdvancedFilters(old => ({ ...old, vehicles: value }));
                }}
                getOptionLabel={option => option.plate}
                getOptionValue={option => option.id}
              />
            </Col>
            <Col md={6} xl={6}>
              <Select.Async
                label={'Implementos'}
                multiple
                horizontal
                onSearch={search => fetchWagons(search)}
                value={advancedFilters.wagons}
                onChange={value => {
                  query.delete('wagons[]');
                  if (value?.length) {
                    value.forEach(v => {
                      query.append('wagons[]', v.id);
                    })
                  }
                  setAdvancedFilters(old => ({ ...old, wagons: value }));
                }}
                getOptionLabel={option => option.plate}
                getOptionValue={option => option.id}
              />
            </Col>
            <Col md={6} xl={6}>
              <Input
                label="Busca por ID"
                type="number"
                placeholder="Digite o identificador do checklist"
                value={advancedFilters.idSearch}
                onChange={(event) => {
                  if (event) {
                    query.set('idSearch', event.target.value);
                  } else {
                    query.delete('idSearch');
                  }
                  setAdvancedFilters(old => ({ ...old, idSearch: event.target.value }))
                }}
              />
            </Col>
            <Col md={6} xl={6}>
              <Input
                label="Expira em (dias)"
                type="number"
                placeholder="Digite o número de dias para expirar"
                value={advancedFilters.expireInDays}
                onChange={(event) => {
                  if (event) {
                    query.set('expireInDays', event.target.value);
                  } else {
                    query.delete('expireInDays');
                  }
                  setAdvancedFilters(old => ({ ...old, expireInDays: event.target.value }))
                }}
              />
            </Col>
          </Row >
        }
        footer={
          < Row >
            <Col>
              <Button
                size="sm"
                onClick={() => handlerAdvancedFilters()}
                disabled={loading}
              >
                <Text weight={500}>Filtrar</Text>
              </Button>
            </Col>
          </Row >
        }
      />
    </>
  );
}
